import { paymentErrors } from '@elab/core/utils/constants';

const getPayment = state => (state && state.payment) || {};

const getMethods = state => getPayment(state).methods || [];
const getSelectedMethod = state => getPayment(state).selectedMethod || {};
const shouldSubscribe = state => getPayment(state).shouldSubscribe;
const termsAccepted = state => getPayment(state).termsAccepted;
const getPayWithLoyaltyPointsMethod = state =>
    getMethods(state).find(({ code }) => code.toLowerCase().includes('paywithpoints'));
const getPayWithLoyaltyPointsMethodEntries = state =>
    (getPayWithLoyaltyPointsMethod(state) || {}).entries;
const getPayWithLoyaltyPointsMethodErrors = state =>
    (getPayWithLoyaltyPointsMethod(state) || {}).errors;
const showPayWithPoints = state => !!getPayment(state).showPayWithPoints;
const isPayWithPointsActive = state => (getPayWithLoyaltyPointsMethod(state) || {}).active;
const isLoading = state => getPayment(state).loading;
const getCartNotFound = state => getPayment(state).cartNotFound || false;
const getSavedCards = state => getPayment(state).savedCards || [];
const getSelectedCard = state => getPayment(state).selectedCard || null;
const getIFrameURL = state => (getPayment(state).iFrame ? getPayment(state).iFrame.url : '');
const getIFrameToken = state => (getPayment(state).iFrame ? getPayment(state).iFrame.token : '');
const getSavedCardFlag = state => (getPayment(state).saveCard ? getPayment(state).saveCard : false);
const getCardHolderName = state =>
    getPayment(state).cardHolderName ? getPayment(state).cardHolderName : '';
const getPayNowActive = state =>
    getPayment(state).payNowActive ? getPayment(state).payNowActive : false;
const getSaveCardUsed = state => getPayment(state).saveCardUsed;
const getRemoveCardType = state =>
    getPayment(state).removeCardType ? getPayment(state).removeCardType : '';
const getRemoveCardNumber = state =>
    getPayment(state).removeCardNumber ? getPayment(state).removeCardNumber : '';
const getRemoveCardId = state =>
    getPayment(state).removeCardId ? getPayment(state).removeCardId : '';

const getTokenizationAllowed = state => getPayment(state).tokenizationAllowed;

const getSavedCardsAvailable = state =>
    getPayment(state).savedCardsAvailable ? getPayment(state).savedCardsAvailable : false;

const getIsPaymentPage = state =>
    getPayment(state).isPaymentPage ? getPayment(state).isPaymentPage : false;

const getGiftCardMethods = state => getPayment(state).giftCardMethods || [];

const getPaymentMethodSet = state => getPayment(state).paymentMethodSet;

const getPaymentSession = state => getPayment(state).sessionData;

const getPaymentErrors = state => getPayment(state).errors || {};

const isPaymentSessionAuthorized = state => getPayment(state).sessionAuthorized;

const getdistanceSellingContract = state => getPayment(state).distanceSellingContract;
const getPreliminaryInformationForm = state => getPayment(state).preliminaryInformationForm;

const getIsNewOrderApiEnabled = state =>
    getPayment(state).isNewOrderApiEnabled ? getPayment(state).isNewOrderApiEnabled : false;

const getPaymentSpecificError = state =>
    getPaymentErrors(state).placeOrderCartValidationResponseError ||
    getPaymentErrors(state).zeroBalanceGiftCardError;

export default {
    getMethods,
    getSavedCards,
    getIFrameURL,
    getIFrameToken,
    getSelectedCard,
    getSavedCardFlag,
    getCardHolderName,
    getPayNowActive,
    getSelectedMethod,
    getCartNotFound,
    shouldSubscribe,
    termsAccepted,
    getPayWithLoyaltyPointsMethod,
    getPayWithLoyaltyPointsMethodEntries,
    getPayWithLoyaltyPointsMethodErrors,
    showPayWithPoints,
    isPayWithPointsActive,
    isLoading,
    getRemoveCardNumber,
    getRemoveCardType,
    getRemoveCardId,
    getSavedCardsAvailable,
    getTokenizationAllowed,
    getSaveCardUsed,
    getIsPaymentPage,
    getGiftCardMethods,
    getPaymentMethodSet,
    getdistanceSellingContract,
    getPreliminaryInformationForm,
    getIsNewOrderApiEnabled,
    getPaymentSession,
    isPaymentSessionAuthorized,
    getPaymentErrors,
    getPaymentSpecificError,
};
